"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MultiLayeredFigureModule = _interopRequireDefault(require("./../../scss/blocks/MultiLayeredFigure.module.scss"));
function MultiLayeredFigure(_ref) {
  let {
    images = [],
    positions = ['center'],
    sizes = ['auto']
  } = _ref;
  const createValue = function () {
    let list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let value = "";
    for (let i = 0; i < list.length; i++) {
      if (type === 'image') {
        if (i === 0) {
          value += "url(\"".concat(list[i], "\")");
        } else {
          value += ",url(\"".concat(list[i], "\")");
        }
      } else {
        if (i === 0) {
          value += "".concat(list[i]);
        } else {
          value += ",".concat(list[i]);
        }
      }
    }
    return value;
  };
  const backgroundPositions = createValue(positions);
  const backgroundImages = createValue(images, 'image');
  const backgroundSizes = createValue(sizes);
  return /*#__PURE__*/_react.default.createElement("figure", {
    className: _MultiLayeredFigureModule.default['multi-layered-figure']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MultiLayeredFigureModule.default['multi-layered-figure__images'],
    style: {
      backgroundImage: backgroundImages,
      backgroundPosition: backgroundPositions,
      backgroundSize: backgroundSizes
    }
  }));
}
var _default = exports.default = MultiLayeredFigure;